import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import { useParams } from 'react-router-dom';
import UniqueLinkAccountType from './UniqueLinkAccountType';

const AdminWithdrawalUniqueLink = () => {
  const { t } = useTranslation();
  const { nationalExamType } = useParams<{ nationalExamType: 'national' | 'non-national' }>();

  let title = t('admin->>UniqueLink.NationalWithdrawals');

  return (
    <>
      <TitleHeader title={title} />

      <UniqueLinkAccountType />
    </>
  );
};
export default AdminWithdrawalUniqueLink;
